/**
 * Trial Mode Guard Composable
 * Wraps click handlers that open Optix panels - shows snackbar when in trial mode instead
 */

import { useDemoMode } from './useDemoMode.js'
import { useSnackbar } from './useSnackbar.js'

const TRIAL_MODE_MESSAGE = 'Disabled in trial mode'

/**
 * Returns a guard function that wraps callbacks. When in trial mode, shows snackbar and returns;
 * otherwise invokes the original callback.
 * @returns {Function} guard(fn) - returns wrapped function
 */
export function useTrialModeGuard() {
  const demoMode = useDemoMode()
  const { show: showSnackbar } = useSnackbar()

  function guard(fn) {
    return (...args) => {
      if (demoMode?.value === true) {
        showSnackbar(TRIAL_MODE_MESSAGE)
        return
      }
      return typeof fn === 'function' ? fn(...args) : undefined
    }
  }

  return { guard }
}
